module.exports = __webpack_public_path__ + "static/media/DashboardIconActive.80e386e5.png";